export default __webpack_public_path__ + "static/SR China - Halal - Certificate-b546d3e1b1c084249f50e3e35b110723.pdf";